<template>
  <div class="pdf-wrapper">
    <iframe :src="url" v-if="isDesktop" width="100%" height="100%"> </iframe>
    <iframe
      v-else
      :src="`https://docs.google.com/gview?url=${fullUrl}&embedded=true`"
      frameBorder="0"
      scrolling="auto"
      height="100%"
      width="100%"
    ></iframe>
  </div>
</template>
<script>
import { entity } from '@/../region.json';
import { topLevelDomains } from '../../shared/entityHelpers';

export default {
  props: ['pdf_url'],
  data() {
    return {
      url: `/${this.pdf_url}-${entity}.pdf`,
      topLevelDomains,
      entity,
    };
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    fullUrl() {
      return `https://qwello.${this.topLevelDomains[this.entity]}${this.url}`;
    },
  },
};
</script>

<style scoped>
.pdf-wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
}
.pdf-wrapper {
  padding-top: 62px;
}
@media (min-width: 767px) {
  .pdf-wrapper {
    padding-top: 68px;
  }
}
@media (min-width: 1024px) {
  .pdf-wrapper {
    padding-top: 76px;
  }
}
</style>
